<div mat-dialog-title class="dialog-header">
    <h4 class="modal-title">{{ workareas.length }} werkvak{{ workareas.length === 1 ? '' : 'ken' }} verplaatsen</h4>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <i class="fal fa-times" aria-hidden="true"></i>
    </button>
</div>
<form [formGroup]="form" (ngSubmit)="transfer()">
    <div mat-dialog-content class="modal-body">
        @if (transferredTo) {
            <p>
                {{ workareas.length }} werkvak{{ workareas.length === 1 ? ' is' : 'ken zijn' }} verplaatst naar
                <strong>{{ transferredTo.name }}</strong> ({{ customer.name }}).
            </p>
        } @else {
            <mat-form-field class="w-100">
                <mat-label>Klantgebied</mat-label>
                <input matInput formControlName="customer" [matAutocomplete]="customerAuto" />
                <mat-autocomplete
                    #customerAuto="matAutocomplete"
                    [displayWith]="displayName"
                    autoActiveFirstOption
                    (optionSelected)="selectCustomer($event.option.value)">
                    @for (customer of filterByName(customers, form.controls.customer.value); track customer.id) {
                        <mat-option [value]="customer">{{ customer.name }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            @if (projects) {
                <mat-form-field class="w-100" floatLabel="always">
                    <mat-label>Project</mat-label>
                    <input
                        matInput
                        formControlName="project"
                        [matAutocomplete]="projectAuto"
                        [placeholder]="
                            projects.length ? 'Selecteer een project' : 'Dit klantgebied heeft geen passend project.'
                        " />
                    <mat-autocomplete #projectAuto="matAutocomplete" [displayWith]="displayName" autoActiveFirstOption>
                        @for (project of filterByName(projects, form.controls.project.value); track project.id) {
                            <mat-option [value]="project">{{ project.name }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            }
            @if (customer && projectTypes.length && (Features.CustomerProjectsSave | hasFeature)) {
                <button type="button" mat-button color="primary" (click)="openNewProject()">
                    <i class="fal fa-plus"></i> Project aanmaken
                </button>
            }
        }
    </div>
    <div mat-dialog-actions class="modal-footer justify-content-between">
        <button color="primary" mat-button mat-dialog-close type="button">
            {{ transferredTo ? 'Sluiten' : 'Annuleren' }}
        </button>
        @if (transferredTo) {
            <a
                color="primary"
                mat-raised-button
                mat-dialog-close
                [routerLink]="[
                    '/',
                    Routenames.customers,
                    customer.id,
                    transferredTo.type === 'drillings' ? Routenames.drillingProjects : Routenames.projects,
                    transferredTo.id,
                ]">
                Doelproject openen
            </a>
        } @else {
            <button color="primary" mat-raised-button type="submit" [disabled]="form.invalid || transferring">
                @if (transferring) {
                    <i class="fal fa-spinner fa-spin"></i> Aan het verplaatsen...
                } @else {
                    Verplaatsen
                }
            </button>
        }
    </div>
</form>
